(function() {
    'use strict';
    angular
        .module('capacitacionCertificacionApp')
        .factory('Certification', Certification);

    Certification.$inject = ['$resource'];

    function Certification ($resource) {
        var resourceUrl =  'api/certifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'submit': { method:'PUT' }
        });
    }
})();
